import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { UIPageStore } from 'stores/ui-page-store';

export interface WelcomeNotificationProps {
  uiPage?: UIPageStore;
  currentHotel?: CurrentHotelStore;
}

@inject('uiPage', 'currentHotel')
@observer
export class WelcomeNotification extends React.Component<WelcomeNotificationProps> {
  public componentDidMount() {
    const { uiPage, currentHotel } = this.props;

    if (
      uiPage &&
      uiPage.showNotification &&
      typeof uiPage.showNotification === 'function' &&
      currentHotel &&
      currentHotel.offers &&
      currentHotel.offers.flyInModel &&
      currentHotel.offers.flyInModel.text &&
      currentHotel.resetFlyinMessage &&
      typeof currentHotel.resetFlyinMessage === 'function'
    ) {
      const message = currentHotel.offers.flyInModel.text;

      uiPage.showNotification(message);
      currentHotel.resetFlyinMessage();
    }
  }

  public render(): JSX.Element {
    return null;
  }
}
